// utils/localizedField.ts
//
// Admin-managed content (categories, sub-categories) carries per-language
// copies as `<field>_<lang>` (e.g. name_ja, description_ar). Picks the copy
// for the user's preferred language, falling back to the base field.
export const LOCALIZED_FIELD_LANGUAGES = [
  "th",
  "es",
  "ja",
  "ko",
  "id",
  "vi",
  "ar",
] as const;

export const localizedField = (
  item: Record<string, any> | null | undefined,
  field: string,
  language: string,
): string => {
  if (!item) return "";
  const localized = language !== "en" ? item[`${field}_${language}`] : "";
  return localized || item[field] || "";
};

/** Copies `field` and every `field_<lang>` variant from a source record. */
export const pickLocalizedFields = (
  source: Record<string, any>,
  fields: string[],
): Record<string, any> => {
  const out: Record<string, any> = {};
  for (const field of fields) {
    out[field] = source[field];
    for (const language of LOCALIZED_FIELD_LANGUAGES) {
      out[`${field}_${language}`] = source[`${field}_${language}`];
    }
  }
  return out;
};
